import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sales-admin-page" }
const _hoisted_2 = { class: "sales-admin-page__section" }

import Tabs from "@shared/Components/Tabs/Tabs.vue";
import OrdersTab from "@features/Pages/SalesAdminPage/Components/OrdersTab/OrdersTab.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SalesAdminPage',
  setup(__props) {

const tabs: TabsItem[] = [
  {
    id: "orders",
    label: "Orders",
  },
  {
    id: "convoys",
    label: "Convoys",
  },
  {
    id: "order-export",
    label: "Order export",
  },
  {
    id: "customer-groups",
    label: "Customer groups",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Tabs, {
      tabs: tabs,
      "aria-label": "Sales admin sections"
    }, {
      orders: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createVNode(OrdersTab)
        ])
      ]),
      convoys: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("section", { class: "sales-admin-page__section" }, [
          _createElementVNode("h2", null, "Convoys"),
          _createElementVNode("p", null, "Coming soon...")
        ], -1 /* CACHED */)
      ]))]),
      "order-export": _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("section", { class: "sales-admin-page__section" }, [
          _createElementVNode("h2", null, "Order export"),
          _createElementVNode("p", null, "Coming soon...")
        ], -1 /* CACHED */)
      ]))]),
      "customer-groups": _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("section", { class: "sales-admin-page__section" }, [
          _createElementVNode("h2", null, "Customer groups"),
          _createElementVNode("p", null, "Run the customer club level updater in its dedicated admin view."),
          _createElementVNode("a", {
            class: "button button--small",
            href: "/sales-admin/customer-groups"
          }, " Open customer groups ")
        ], -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})